import { render, staticRenderFns } from "./CustomerRecentActivity.vue?vue&type=template&id=960f703a&scoped=true&"
import script from "./CustomerRecentActivity.vue?vue&type=script&lang=ts&"
export * from "./CustomerRecentActivity.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerRecentActivity.vue?vue&type=style&index=0&id=960f703a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960f703a",
  null
  
)

export default component.exports